export class RolesSelected {
  universalId?: string;
  name?: string;
}
